export function normalizeDocument(value: string): string {
  return value.replace(/\D/g, '').slice(0, 14)
}

function hasRepeatedDigits(value: string): boolean {
  return /^(\d)\1+$/.test(value)
}

export function isValidCpf(value: string): boolean {
  const digits = normalizeDocument(value)
  if (digits.length !== 11 || hasRepeatedDigits(digits)) return false

  const calculate = (length: number) => {
    const total = digits
      .slice(0, length)
      .split('')
      .reduce((sum, digit, index) => sum + Number(digit) * (length + 1 - index), 0)
    const remainder = 11 - (total % 11)
    return remainder >= 10 ? 0 : remainder
  }

  return calculate(9) === Number(digits[9]) && calculate(10) === Number(digits[10])
}

export function isValidCnpj(value: string): boolean {
  const digits = normalizeDocument(value)
  if (digits.length !== 14 || hasRepeatedDigits(digits)) return false

  const calculate = (length: number) => {
    const weights = length === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const total = digits
      .slice(0, length)
      .split('')
      .reduce((sum, digit, index) => sum + Number(digit) * weights[index], 0)
    const remainder = total % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  return calculate(12) === Number(digits[12]) && calculate(13) === Number(digits[13])
}

export function isValidCpfCnpj(value: string): boolean {
  const digits = normalizeDocument(value)
  return digits.length === 11 ? isValidCpf(digits) : isValidCnpj(digits)
}

export function formatDocument(value: string | null | undefined): string {
  const digits = normalizeDocument(value ?? '')
  if (digits.length <= 11) {
    return digits
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2')
  }
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
}
